/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconAperture = createSolidComponent("aperture", "IconAperture", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" }],
  ["path", { d: "M3.6 15h10.55" }],
  ["path", { d: "M6.551 4.938l3.26 10.034" }],
  ["path", { d: "M17.032 4.636l-8.535 6.201" }],
  ["path", { d: "M20.559 14.51l-8.535 -6.201" }],
  ["path", { d: "M12.257 20.916l3.261 -10.034" }]
]);

export { IconAperture as default };
//# sourceMappingURL=IconAperture.js.map
